import { Box, DataList, Flex } from '@volue/wave-react';
import React from 'react';

import type { SelectedGridElement } from '../../../overmind/calculation';
import { InlineInfoNotificationSmallIcon } from '../InlineNotification';
import { LoadFlowDetailsHeader } from './LoadFlowDetailsHeader';

export const ExternalNetworkDetails: React.FunctionComponent<{
  externalNetworkInjection: SelectedGridElement<'ExternalNetworkInjection'>;
}> = ({ externalNetworkInjection }) => {
  const text =
    'This element is the external network injection in these calculations';
  return (
    <>
      {InlineInfoNotificationSmallIcon({ text })}
      <>
        {externalNetworkInjection.loadflow.type === 'LOAD_FLOW_DETAILS' && (
          <Flex flow="column" gap={'spacingXs'}>
            <LoadFlowDetailsHeader
              scenarioName={
                externalNetworkInjection.loadflow.details.scenarioName
              }
            />
            {
              <DataList className="mHxl">
                <Flex as={DataList.Row} main="space-between">
                  <DataList.Label>{'Voltage'}</DataList.Label>
                  <Flex main={'end'} as={DataList.Value}>
                    {externalNetworkInjection.loadflow.details.inputs.voltage.toString()}
                  </Flex>
                </Flex>
              </DataList>
            }
          </Flex>
        )}
        {externalNetworkInjection.shortCircuit.type ===
          'SHORT_CIRCUIT_DETAILS' && (
          <Flex flow="column" gap={'spacingXs'}>
            <Box css={{ color: '$colorAccent70', fontWeight: 'bolder' }}>
              {'Short Circuit'}
            </Box>
            <Box css={{ color: '$colorBlack60', fontWeight: 'bolder' }}>
              {'Max'}
            </Box>
            <DataList className="mHxl" ratio={[3, 1]}>
              <Flex as={DataList.Row} main="space-between">
                <DataList.Label>{'Power Provision'}</DataList.Label>
                <Flex main={'end'} as={DataList.Value}>
                  {externalNetworkInjection.shortCircuit.evaluatedResults.inputs.maxInitialSymShCCurrent.toString()}
                </Flex>
              </Flex>
              <Flex as={DataList.Row} main="space-between">
                <DataList.Label>{'R/X'}</DataList.Label>
                <Flex main={'end'} as={DataList.Value}>
                  {
                    externalNetworkInjection.shortCircuit.evaluatedResults
                      .inputs.maxPowerFactor
                  }
                </Flex>
              </Flex>
            </DataList>
            <Box css={{ color: '$colorBlack60', fontWeight: 'bolder' }}>
              {'Min'}
            </Box>
            <DataList className="mHxl" ratio={[3, 1]}>
              <Flex as={DataList.Row} main="space-between">
                <DataList.Label>{'Power Provision'}</DataList.Label>
                <Flex main={'end'} as={DataList.Value}>
                  {externalNetworkInjection.shortCircuit.evaluatedResults.inputs.minInitialSymShCCurrent.toString()}
                </Flex>
              </Flex>
              <Flex as={DataList.Row} main="space-between">
                <DataList.Label>{'R/X'}</DataList.Label>
                <Flex main={'end'} as={DataList.Value}>
                  {
                    externalNetworkInjection.shortCircuit.evaluatedResults
                      .inputs.minPowerFactor
                  }
                </Flex>
              </Flex>
            </DataList>
          </Flex>
        )}
      </>
    </>
  );
};
